function scroll() {
    try {
        window.dispatchEvent(new CustomEvent('scroll'));
    } catch (error) {
        console.warn('Cannot trigger scroll event');
    }
}

export default scroll;
